import { useState, useEffect } from 'react';

// appUrls = /api/appurls list; appUrlValue = chuna hua AppUrl _id (default: current domain wala) — guru99admin jaisa
const SuperAdminForm = ({ formData, handleChange, handleNumberWheel, handleSubmit, loading, createUserLoading, error, parentDetails, appUrls = [], appUrlValue = '', isEdit = false }) => {
  const inputClass = "w-full border border-gray-300 px-3 py-2 focus:outline-none focus:border-blue-500 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
  const labelClass = "block text-gray-700 text-sm mb-1";
  const disabledInputClass = "w-full border border-gray-300 px-3 py-2 bg-gray-100 text-gray-700 cursor-not-allowed";
  const errorInputClass = "w-full border-2 border-red-500 px-3 py-2 focus:outline-none focus:border-red-500 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";

  const [myShareError, setMyShareError] = useState('');

  useEffect(() => {
    if (formData.myShare && parseFloat(formData.myShare) > (parentDetails?.shares?.myShare || 0)) {
      setMyShareError(`Cannot exceed My Match Share (${parentDetails?.shares?.myShare?.toFixed(2) || '0.00'}%)`);
    } else {
      setMyShareError('');
    }
  }, [formData.myShare, parentDetails]);

  const handleFormSubmit = (event) => {
    if (myShareError) {
      event.preventDefault();
      return;
    }
    handleSubmit(event);
  };

  return (
    <form onSubmit={handleFormSubmit} className="px-4 py-4">
      {/* Basic Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 mb-4">
        <div>
          <label className={labelClass}>
            Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Enter full name"
            className={inputClass}
            required
          />
        </div>

        {isEdit ? (
          <div>
            <label className={labelClass}>Status <span className="text-red-500">*</span></label>
            <select name="status" value={formData.status || 'active'} onChange={handleChange} className={inputClass}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        ) : (
          <>
            <div>
              <label className={labelClass}>My Coins</label>
              <input type="text" value={parentDetails?.availableBalance?.toFixed(2) || "0.00"} disabled className={disabledInputClass} />
            </div>
            <div>
              <label className={labelClass}>Coins <span className="text-red-500">*</span></label>
              <input type="number" name="exposureLimit" value={formData.exposureLimit} onChange={handleChange} onWheel={handleNumberWheel} placeholder="SuperAdmin Coins" className={inputClass} required />
            </div>
            {/* SuperAdmin kis domain (white-label) ka hai — uski poori downline usi domain pe login karti hai.
                Coins ke bagal me (ek row me 2 input) */}
            <div>
              <label className={labelClass}>App URL <span className="text-red-500">*</span></label>
              <select name="appUrl" value={appUrlValue} onChange={handleChange} className={inputClass} required>
                <option value="">-- Select App URL --</option>
                {appUrls.map((app) => (
                  <option key={app._id} value={app._id}>
                    {app.url ? `${app.name || app.url} (${app.url})` : app.name || app._id}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <div>
          <label className={labelClass}>Reference</label>
          <input
            type="text"
            name="reference"
            value={formData.reference || ''}
            onChange={handleChange}
            placeholder="Enter reference"
            className={inputClass}
          />
        </div>
      </div>

      {/* Match Share and Commission */}
      <h1 className="text-lg font-semibold mb-3 mt-6">
        SuperAdmin Match Share And Commission
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 mb-4">
        <div>
          <label className={labelClass}>My Match Share(%)</label>
          <input
            type="text"
            value={parentDetails?.shares?.myShare?.toFixed(2) || "0.00"}
            disabled
            className={disabledInputClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Match Share (%) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            name="myShare"
            value={formData.myShare}
            onChange={handleChange}
            onWheel={handleNumberWheel}
            placeholder="SuperAdmin Match Share"
            className={myShareError ? errorInputClass : inputClass}
            required
          />
          {myShareError && (
            <p className="text-red-500 text-xs mt-1">{myShareError}</p>
          )}
        </div>

        <div>
          <label className={labelClass}>My Match comm</label>
          <input
            type="text"
            value={parentDetails?.shares?.matchCommission?.toFixed(2) || "0.00"}
            disabled
            className={disabledInputClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Match comm (%) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            min="0"
            name="matchCommission"
            value={formData.matchCommission}
            onChange={handleChange}
            onWheel={handleNumberWheel}
            placeholder="SuperAdmin Match Commission"
            className={inputClass}
            required
          />
        </div>

        <div>
          <label className={labelClass}>My Sess comm</label>
          <input
            type="text"
            value={parentDetails?.shares?.sessionCommission?.toFixed(2) || "0.00"}
            disabled
            className={disabledInputClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Sess comm (%) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            min="0"
            name="sessionCommission"
            value={formData.sessionCommission}
            onChange={handleChange}
            onWheel={handleNumberWheel}
            placeholder="SuperAdmin Session Commission"
            className={inputClass}
            required
          />
        </div>
      </div>

      {/* Casino Share and Commission */}
      <h1 className="text-lg font-semibold mb-3 mt-6">
        SuperAdmin Casino Share And Commission
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 mb-4">
        <div>
          <label className={labelClass}>My Casino comm</label>
          <input
            type="text"
            value={parentDetails?.shares?.casinoCommission?.toFixed(2) || "0.00"}
            disabled
            className={disabledInputClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Casino comm (%) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            name="casinoCommission"
            value={formData.casinoCommission}
            onChange={handleChange}
            onWheel={handleNumberWheel}
            placeholder="SuperAdmin Casino Commission"
            className={inputClass}
            required
          />
        </div>

        <div>
          <label className={labelClass}>My Matka comm(%)</label>
          <input
            type="text"
            value={parentDetails?.shares?.matkaCommission?.toFixed(2) || "0.00"}
            disabled
            className={disabledInputClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Matka comm (%) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            name="matkaCommission"
            value={formData.matkaCommission}
            onChange={handleChange}
            onWheel={handleNumberWheel}
            placeholder="SuperAdmin Matka Commission"
            className={inputClass}
            required
          />
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}

      {/* Submit Button */}
      <div className="flex justify-end">
        <button
          type="submit"
          disabled={loading || createUserLoading}
          className="bg-blue-500 text-white px-8 py-2 hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed"
        >
          {loading || createUserLoading ? "Creating..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default SuperAdminForm;
